import {Component, OnInit} from '@angular/core';
import {InputText} from 'primeng/inputtext';
import {FormBuilder, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ButtonDirective} from 'primeng/button';
import {Toast} from 'primeng/toast';
import {NgClass, NgStyle} from '@angular/common';
import {MessageService} from 'primeng/api';
import {Tooltip} from 'primeng/tooltip';
import {AuthConfigService, AuthFacade} from '@abydos-angular/rest-api';
import {AbydosConfigService} from '@abydos-angular/core';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {Router} from '@angular/router';

@Component({
    selector: 'app-login',
    imports: [
        InputText,
        ReactiveFormsModule,
        ButtonDirective,
        FormsModule,
        Toast,
        NgStyle,
        NgClass,
        Tooltip,
    ],
    templateUrl: './login.component.html',
    standalone: true,
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit{
    form: any;

    constructor(private formBuilder: FormBuilder, private messageService: MessageService,
                private authFacade: AuthFacade, private authConfigService: AuthConfigService,
                private abydosConfigService: AbydosConfigService, private router: Router) {
    }

    ngOnInit() {
        if (isNotNullOrUndefined(this.authFacade.currentUserInfo)) {
            // @ts-ignore
            const navigateTo: any = this.authConfigService.getAuthConfig().onRouteWithRole((this.authFacade.currentUserInfo?.selectedRole as string), this.authFacade)
            this.router.navigateByUrl(navigateTo).then();
        }
        this.initForm()
    }

    initForm() {
        this.form = this.formBuilder.group({
            user: [this.abydosConfigService.getEnvironment().defaultUser, Validators.required],
            password: [this.abydosConfigService.getEnvironment().defaultPassword, Validators.required],
        })
    }

    submitForm() {
        Object.values(this.form.controls).forEach((control: any) => control.markAsDirty());
        this.form.markAllAsTouched();
        if (this.form.valid) {
            this.authFacade.login({...this.form.value, client: this.authConfigService.getAuthConfig()!.loginScope});
        } else {
            this.showErrorMessage();
        }
    }

    showErrorMessage() {
        this.messageService.add({severity: 'error', summary: 'Nem megfelelő adatok', detail: 'Tekintse át az űrlapot, és a pirossal jelzett részeket javítsa!',
            key: 'center', sticky: true, closable: false});
    }

    clearToasts() {
        this.messageService.clear();
    }

}
